function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
import PropTypes from "prop-types";
var SvgDownloadCloud = function SvgDownloadCloud(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12.75 19.21l2.729-2.728a.75.75 0 111.06 1.06l-4 4a.748.748 0 01-.534.22H12a.749.749 0 01-.595-.294l-3.926-3.926a.75.75 0 011.06-1.06l2.711 2.71v-7.18a.75.75 0 011.5 0v7.198zM10.001 2.308a8.75 8.75 0 017.31 5.954h.697a5.75 5.75 0 013.312 10.453.75.75 0 01-.862-1.227 4.25 4.25 0 00-2.449-7.726h-1.26a.75.75 0 01-.726-.564A7.25 7.25 0 103.57 15.805a.75.75 0 01-1.124.994 8.75 8.75 0 017.554-14.491z"
  }));
};
SvgDownloadCloud.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgDownloadCloud.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgDownloadCloud;